<template>
  <div class="login">
    <div class="login-form">
      <h3>Sign In</h3>
      <InputField 
      class="top-spacing" 
      :title="'Email'" 
      v-model="email"
      v-on:keyup="login"/>
      <p v-show="hasEmailValidationMessage" class="validation-message">{{ emailValidationMessage }}</p>

      <InputField 
      class="top-spacing" 
      :title="'Password'" 
      :isPassword="true" 
      v-model="password"
      v-on:keyup="login"/>

      <div v-show="loading" class="loading-container">
        <circle6 class="loading-indicator"></circle6>
      </div>
        
      <button :class="{disabled : loading, disabled : !canLogin}" class="top-spacing" v-on:click="login">Login</button>
      <button
        :class="{disabled : loading}"
        class="top-spacing invert-cta"
        v-on:click="signUp"
      >Sign Up</button>

      <div class="divider"/>

      <p v-show="!loading" class="body-text">Sign in with a Social account</p>

      <div v-show="!loading" @click="socialLogin" class="social-button">
        <div>Sign in with Google</div>
        <div class="colour-block"></div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import InputField from "@/components/InputField.vue";
import { Circle6 } from "vue-loading-spinner";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "Login",
  components: {
    InputField,
    Circle6
  },
  data() {
    return {
      email: "",
      password: "",
      emailValidationMessage: "",
      loading: false
    };
  },
  mounted() {
    this.UPDATE_NAVIGATION_BAR_STATE(2);
  },
  watch: {
    email: function(email) {
      if (email.length > 0) {
        if (!this.validateEmail(email)) {
          this.emailValidationMessage = "Please enter a valid email address";
        } else {
          this.emailValidationMessage = "";
        }
      }

      if (email.length == 0) {
        this.emailValidationMessage = "";
      }
    }
  },
  computed: {
    hasEmailValidationMessage() {
      return this.emailValidationMessage != "";
    },
    canLogin() {
      return !this.hasEmailValidationMessage && this.email != '' && this.password != '';
    }
  },
  methods: {
    ...mapMutations(['UPDATE_NAVIGATION_BAR_STATE']),
    ...mapActions(["loginUser", "performSocialLogin"]),
    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    signUp() {
      this.$router.push("sign-up");
    },
    login() {
      
      if (!this.loading && this.canLogin) {
        this.loading = true;
        // console.log("Login with: " + this.email + " And " + this.password);
        // Move this into the store.js

        this.loginUser({
          email: this.email,
          password: this.password
        }).then(
          () => {
            this.loading = false;
            this.$router.replace("dashboard");
          },
          err => {
            this.loading = false;
            this.$modal.show('info-modal',{ title: 'Login Failed', modalError:  `${err.message}`});
          }
        );
      }
    },
    socialLogin() {
      const provider = new firebase.auth.GoogleAuthProvider();

      this.performSocialLogin()
        .then(result => {
          this.$router.replace("dashboard");
        })
        .catch(err => {
          this.$modal.show('info-modal',{ title:'Social Login Failed', modalError:  `Cannot log you in at this time: ${err.message}`});
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/styles.scss";

.invert-cta {
  float: right;
}



.disabled {
  background-color: grey;
  color: white;
  outline: none;
}

span {
  box-sizing: border-box;
  padding-left: 25px;
}

.login {
  display: grid;
  grid-template-areas: ". login-form .";
  grid-template-columns: auto 300px auto;
}

.login-form {
  grid-area: login-form;
}

.validation-message {
  color: $validation-message-color;
  font-weight: 400;
  margin-top: 10px;
}

.social-button {
  margin-top: 25px;
  box-sizing: border-box;
  width: 300px;
  background: white;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 35px;
  color: black;
  border-radius: 5px;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 14px;
  position: relative;

  cursor: pointer;
}

.colour-block {
  width: 50px;
  background-color: #cf3535;
  height: 49px;
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 5px 5px 0;
}

p {
  margin-top: 40px;
}

.divider {
  $divider-margin: 35px;

  width: 300px;
  height: 3px;

  margin-top: $divider-margin;
  margin-bottom: $divider-margin;

  background-color: $light-grey-color;
}

.top-spacing {
  margin-top: 30px;
}
</style>
